import styled from "styled-components"

export const InstructionsTitlesContainer = styled.div`

    display: flex;
    gap: 20px;

`